/**
 * Seller trust helpers — safe fallbacks for missing data.
 */
import i18n from '../i18n';
import { formatTimeAgo } from './timeAgo';
import { formatMemberSince } from './dataConsistency';

const t = (key) => i18n.t(key);

// Re-export formatTimeAgo from the single source (timeAgo.js)
export { formatTimeAgo };

export function formatTimeAgoAr(dateValue) {
  return formatTimeAgo(dateValue, 'ar');
}

export function getSellerTrustLabel(product, isRTL = false) {
  const seller = product?.seller || {};
  if (seller?.is_verified || seller?.isVerified || seller?.verification?.status === 'verified') {
    return t('selltrus.verifiedSeller');
  }
  if (seller?.phoneVerified || seller?.phone_verified) {
    return t('selltrus.phoneVerified');
  }
  if (seller?.responseSpeed === 'fast' || seller?.repliesFast) {
    return t('selltrus.repliesFast');
  }
  return '';
}

export function getPostedAgo(product, isRTL = false) {
  const dateVal = product?.created_at || product?.createdAt;
  return formatTimeAgo(dateVal, isRTL ? 'ar' : 'en');
}

export function getSellerBadge(seller) {
  if (!seller) return '';
  let score = 0;
  if (seller.phoneVerified || seller.phone_verified) score += 30;
  if (seller.is_verified || seller.isVerified || seller.verification?.status === 'verified') score += 30;
  if (seller.joinedAt || seller.joined_at) score += 10;
  if (seller.responseSpeed === 'fast' || seller.repliesFast) score += 20;
  if ((seller.activeListingsCount || seller.active_listings_count || 0) >= 3) score += 10;
  if (score >= 60) return 'Verified Seller';
  if (score >= 30) return 'Active Seller';
  return '';
}

// Re-export from shared data consistency module — ONE source of truth
export { formatMemberSince };
